import { AuthGuard } from '../app.authGuard';

import { ChcComponent } from './chc/chc.component';
import { PhBhpChcConfigureComponent } from './ph-bhp-chc-configure/ph-bhp-chc-configure.component';
import { Route } from "@angular/router";

export var ChcRouterModule: Route =      {
  path: 'chc', component: ChcComponent, children: [
    { path: 'configure', component: PhBhpChcConfigureComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: 'configure', pathMatch: 'full', canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'configure', canActivate: [AuthGuard] }
  ]
};
